(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenepet-cart"]) return;
  try {
    
function initializeSerenePetCart(){
  const dialog=document.querySelector('[data-sp-cart-drawer]');
  if(!dialog || dialog.dataset.initialized)return;
  dialog.dataset.initialized='true';
  const messages=JSON.parse(document.querySelector('[data-sp-cart-messages]').textContent);
  const sectionId='serenepet-cart';
  const error=dialog.querySelector('[data-sp-cart-error]');
  let busy=false;
  const body=()=>dialog.querySelector('[data-sp-cart-body]');
  function report(message){error.textContent=message || messages.error;error.hidden=false;}
  function render(html){
    if(!html)return false;
    const content=new DOMParser().parseFromString(html,'text/html').querySelector('[data-sp-cart-body]');
    if(!content)return false;
    body().replaceWith(content);
    if(typeof window.bucksCC?.reConvert==='function')window.bucksCC.reConvert();
    return true;
  }
  async function refresh(){
    const url=new URL(window.Shopify.routes.root,window.location.origin);
    url.searchParams.set('sections',sectionId);
    const response=await fetch(url.toString(),{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error(messages.error);
    const sections=await response.json();
    if(!render(sections[sectionId]))throw new Error(messages.error);
  }
  async function show(html){
    error.hidden=true;
    if(!dialog.open)dialog.showModal();
    try{if(!render(html))await refresh();}catch(failure){report(failure.message);}
    dialog.querySelector('[data-sp-cart-close]')?.focus({preventScroll:true});
  }
  async function change(line,quantity){
    if(busy || !Number.isInteger(quantity) || quantity<0)return;
    busy=true;
    body().setAttribute('aria-busy','true');
    error.hidden=true;
    try{
      const response=await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity,sections:[sectionId],sections_url:window.location.pathname})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description || result.message || messages.error);
      if(!render(result.sections?.[sectionId]))await refresh();
    }catch(failure){report(failure.message);try{await refresh();}catch{}}
    finally{busy=false;body().removeAttribute('aria-busy');}
  }
  dialog.addEventListener('click',event=>{
    if(event.target===dialog){const rectangle=dialog.getBoundingClientRect();if(event.clientX<rectangle.left || event.clientX>rectangle.right)dialog.close();return;}
    const control=event.target.closest('button');
    if(!control)return;
    if(control.hasAttribute('data-sp-cart-close')){dialog.close();return;}
    const item=control.closest('[data-sp-cart-line]');
    if(!item)return;
    if(control.hasAttribute('data-sp-cart-remove'))change(Number(item.dataset.spCartLine),0);
    if(control.hasAttribute('data-sp-cart-step'))change(Number(item.dataset.spCartLine),Math.max(0,Number(item.querySelector('[data-sp-cart-quantity]').value)+Number(control.dataset.spCartStep)));
  });
  dialog.addEventListener('change',event=>{
    if(!event.target.matches('[data-sp-cart-quantity]'))return;
    const item=event.target.closest('[data-sp-cart-line]');
    change(Number(item.dataset.spCartLine),Number(event.target.value));
  });
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-sp-open-cart]');
    if(!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    event.preventDefault();
    show();
  });
  window.SerenePetCart={show,refresh};
}
initializeSerenePetCart();
document.addEventListener('shopify:section:load',initializeSerenePetCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenepet-navigation"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sp-menu]').forEach(menu=>{
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
  document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenepet-product"] && !Shopify.designMode) return;
  try {
    

function initializeSerenePet(root) {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
  const slides=[...root.querySelectorAll('[data-sf-slide]')];
  const thumbs=[...root.querySelectorAll('[data-sf-thumb]')];
  let photo=1;
  function showPhoto(next){if(!slides.length)return;photo=((next-1+slides.length)%slides.length)+1;slides.forEach(el=>el.hidden=Number(el.dataset.sfSlide)!==photo);thumbs.forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.sfThumb)===photo)));}
  thumbs.forEach(el=>el.addEventListener('click',()=>showPhoto(Number(el.dataset.sfThumb))));
  root.querySelector('[data-sf-gallery-prev]')?.addEventListener('click',()=>showPhoto(photo-1));
  root.querySelector('[data-sf-gallery-next]')?.addEventListener('click',()=>showPhoto(photo+1));
  const form=root.querySelector('.sf-purchase-form');
  if(!form)return;
  const messages=JSON.parse(root.querySelector('[data-sf-messages]').textContent);
  const variants=JSON.parse(root.querySelector('[data-sf-variants]').textContent);
  const button=root.querySelector('[data-sf-add]');
  const labels=[...root.querySelectorAll('[data-sf-add-for]')];
  const state=root.querySelector('[data-sf-add-state]');
  const error=root.querySelector('[data-sf-error]');
  let busy=false;
  const selected=()=>form.querySelector('[data-sf-pack-variant]:checked');
  const cardFor=pack=>pack?.closest('.sfg-pack');
  const choicesFor=pack=>[...cardFor(pack)?.querySelectorAll('[data-sf-unit-variant]')||[]];
  function showState(text){labels.forEach(el=>el.hidden=true);if(state){state.textContent=text;state.hidden=false;}}
  function showPackLabel(pack){
    const match=pack&&labels.find(el=>el.dataset.sfAddFor===pack.value);
    if(!match){showState(messages.add);return;}
    if(state)state.hidden=true;
    labels.forEach(el=>el.hidden=el!==match);
  }
  function refreshPhoto(select){
    const variant=variants.find(item=>String(item.id)===select.value);
    const image=select.closest('.sfg-choice-row').querySelector('.sfg-choice-image');
    if(image&&variant?.image){image.src=variant.image;image.removeAttribute('srcset');image.alt=variant.color;}
  }
  function update(){
    const pack=selected();
    form.querySelectorAll('[data-sf-pack-variant]').forEach(input=>{
      const card=cardFor(input);const active=input===pack;
      card.classList.toggle('is-selected',active);
      card.querySelector('[data-sf-choices]').hidden=!active;
      choicesFor(input).forEach(select=>{select.disabled=!active;refreshPhoto(select);});
      const first=variants.find(item=>String(item.id)===choicesFor(input)[0]?.value);
      const priced=variants.find(item=>item.units===Number(input.dataset.sfUnits)&&item.color===first?.color);
      if(priced)input.value=String(priced.id);
    });
    const choices=choicesFor(pack);
    const ready=choices.length===Number(pack?.dataset.sfUnits)&&choices.every(select=>variants.some(item=>String(item.id)===select.value&&item.available));
    if(choices[0])form.querySelector('[data-sf-native-id]').value=choices[0].value;
    form.querySelector('[data-sf-native-quantity]').value=pack?.dataset.sfUnits||'1';
    button.disabled=busy||!ready;
    if(ready)showPackLabel(pack);else showState(messages.sold_out);
    error.hidden=true;
  }
  function updateSelection(select){
    update();
    const first=select||choicesFor(selected())[0];
    const variant=variants.find(item=>String(item.id)===first?.value);
    const index=variant&&slides.findIndex(slide=>slide.dataset.sfImageId===String(variant.image_id));
    if(index>=0)showPhoto(index+1);
    const priced=selected();
    if(priced){const url=new URL(window.location.href);url.searchParams.set('variant',priced.value);window.history.replaceState({},'',url);}
  }
  form.querySelectorAll('[data-sf-unit-variant]').forEach(select=>select.addEventListener('change',()=>updateSelection(select)));
  form.querySelectorAll('[data-sf-pack-variant]').forEach(input=>input.addEventListener('change',()=>updateSelection()));
  form.addEventListener('submit',async event=>{
    event.preventDefault();const pack=selected();if(!pack||button.disabled||busy)return;
    const items=[];
    for(const select of choicesFor(pack)){
      const variant=variants.find(item=>String(item.id)===select.value&&item.available);
      if(!variant)return;
      const existing=items.find(item=>item.id===variant.id);
      if(existing)existing.quantity+=1;else items.push({id:variant.id,quantity:1});
    }
    if(items.reduce((total,item)=>total+item.quantity,0)!==Number(pack.dataset.sfUnits))return;
    busy=true;button.disabled=true;showState(messages.loading);
    try{
      const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:['serenepet-cart'],sections_url:window.location.pathname})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||messages.error);
      if(window.SerenePetCart)await window.SerenePetCart.show(result.sections?.['serenepet-cart']);else window.location.assign(root.dataset.cartUrl);
    }catch(failure){error.textContent=failure.message||messages.error;error.hidden=false;}
    finally{busy=false;button.disabled=false;showPackLabel(selected());}
  });
  update();
  const sticky=root.querySelector('.sf-sticky');
  if(sticky){const observer=new IntersectionObserver(entries=>sticky.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:0});observer.observe(root.querySelector('#sf-buy'));}
}
document.querySelectorAll('[data-sp-product-section]').forEach(initializeSerenePet);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sp-product-section]').forEach(initializeSerenePet));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenepet-tracking"] && !Shopify.designMode) return;
  try {
    
let sereneTrackingScript;
function loadSereneTracking(){if(window.YQV5)return Promise.resolve();if(!sereneTrackingScript)sereneTrackingScript=new Promise((resolve,reject)=>{const script=document.createElement('script');script.src='https://www.17track.net/externalcall.js';script.async=true;script.onload=()=>window.YQV5?resolve():reject();script.onerror=reject;document.head.append(script);});return sereneTrackingScript;}
function initSereneTracking(){document.querySelectorAll('[data-sp-tracking]').forEach(root=>{const form=root.querySelector('[data-sp-tracking-form]');if(form.dataset.ready)return;form.dataset.ready='true';form.addEventListener('submit',async event=>{event.preventDefault();const number=form.elements.nums.value.trim();if(!number)return;const status=root.querySelector('[data-sp-track-status]');const fallback=root.querySelector('[data-sp-track-fallback]');fallback.querySelector('a').href='https://t.17track.net/es?nums='+encodeURIComponent(number);status.hidden=false;status.textContent=root.dataset.loading;fallback.hidden=false;try{await loadSereneTracking();window.YQV5.trackSingle({YQ_ContainerId:'SerenePetTrackingResult',YQ_Height:560,YQ_Fc:'0',YQ_Lang:'es',YQ_Num:number});status.hidden=true;}catch{status.textContent=root.dataset.error;}});});}
initSereneTracking();document.addEventListener('shopify:section:load',initSereneTracking);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenepet-videos"] && !Shopify.designMode) return;
  try {
    
function initializeSerenePetVideos(root){
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const track=root.querySelector('[data-sfv-track]');if(!track)return;
  root.querySelectorAll('[data-sfv-play]').forEach(button=>button.addEventListener('click',()=>{
    const card=button.closest('.sfv-card');const video=card.querySelector('video');if(!video)return;
    if(video.paused){root.querySelectorAll('video').forEach(other=>{if(other!==video){other.pause();other.closest('.sfv-card')?.classList.remove('is-playing');}});video.muted=false;video.play();card.classList.add('is-playing');}
    else{video.pause();card.classList.remove('is-playing');}
  }));
  const step=()=>(track.querySelector('.sfv-card')?.offsetWidth||280)+14;
  root.querySelector('[data-sfv-prev]')?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
  root.querySelector('[data-sfv-next]')?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
}
document.querySelectorAll('[data-sfv]').forEach(initializeSerenePetVideos);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sfv]').forEach(initializeSerenePetVideos));

  } catch(e) { console.error(e); }
})();
})();
